import cloneDeep from 'lodash-es/cloneDeep';

export function deepCopy<T>(obj: T): T {
	return cloneDeep<T>(obj);
}

export function objectify<T>(obj: T): Record<string, string> {
	return JSON.parse(JSON.stringify(obj));
}
